export default __webpack_public_path__ + "0f38e5e8184f7c325e05d5e5c2129549.png";